import { atom } from 'recoil';

export const hasReadAlarm = atom<any>({
  key: 'hasReadAlarm',
  default: null,
});
